/**
 * Spanish Dashboard Content - UI strings for Spanish dashboard at /es/dashboard
 * This file contains all translatable strings for the dashboard interface.
 */
window.SpanishDashboardContent = {
    // ==========================================
    // HEADER & NAVIGATION
    // ==========================================
    header: {
        dashboard: "Panel de Control",
        responses: "Respuestas",
        myForms: "Mis Formularios",
        signOut: "Cerrar Sesión",
        upgrade: "Actualizar",
        free: "Gratis",
        basic: "Evento Pro",
        premium: "Signature",
        viewOnly: "Solo Lectura"
    },

    // ==========================================
    // TAB NAVIGATION
    // ==========================================
    tabs: {
        responses: "Respuestas",
        analytics: "Estadísticas",
        campaigns: "Mensajes a Invitados",
        export: "Exportar"
    },

    // ==========================================
    // RESPONSES TAB
    // ==========================================
    responses: {
        title: "Respuestas",
        totalResponses: "Total de Respuestas",
        attending: "Asistirán",
        notAttending: "No Asistirán",
        maybe: "Quizás",
        adults: "Adultos",
        children: "Niños",
        searchPlaceholder: "Buscar por nombre, email o teléfono...",
        filterAll: "Todas las Respuestas",
        filterYes: "Sí - Asistirán",
        filterNo: "No - No Asistirán",
        filterMaybe: "Quizás",
        noResponses: "No hay respuestas todavía",
        noResponsesDesc: "Las respuestas aparecerán aquí cuando los invitados confirmen su asistencia.",
        shareFirstDesc: "Comparte el enlace con tus invitados. Sus respuestas aparecerán aquí.",
        sendInvitations: "Enviar invitaciones",
        copyLink: "Copiar enlace",
        generalLink: "Enlace general",
        personalLinks: "Enlaces personales",
        loading: "Cargando respuestas...",
        deleteConfirm: "¿Estás seguro de que deseas eliminar esta respuesta?",
        deleteSuccess: "Respuesta eliminada exitosamente",
        saveSuccess: "Cambios guardados exitosamente",
        saveError: "Error al guardar los cambios"
    },

    // ==========================================
    // TABLE HEADERS
    // ==========================================
    table: {
        name: "Nombre",
        email: "Correo Electrónico",
        phone: "Teléfono",
        attending: "Asistencia",
        guestCount: "Invitados",
        dietary: "Dieta",
        relationship: "Relación",
        message: "Mensaje",
        submittedAt: "Fecha de Envío",
        actions: "Acciones",
        yes: "Sí",
        no: "No",
        maybe: "Quizás"
    },

    // ==========================================
    // ANALYTICS TAB
    // ==========================================
    analytics: {
        title: "Estadísticas del Evento",
        responseRate: "Tasa de Respuesta",
        totalInvited: "Total Invitados",
        totalResponded: "Total Respondidos",
        pending: "Pendientes",
        attendanceBreakdown: "Desglose de Asistencia",
        guestBreakdown: "Desglose de Invitados",
        responseTimeline: "Línea de Tiempo de Respuestas",
        dietaryPreferences: "Preferencias Dietéticas",
        relationships: "Relaciones",
        setupTracking: "Configurar Seguimiento",
        setupTrackingDesc: "Ingresa el número de invitaciones enviadas para ver las estadísticas de tasa de respuesta.",
        invitationsSent: "Invitaciones Enviadas",
        manualCount: "Conteo Manual",
        autoDetection: "Detección Automática",
        switchToAuto: "¿Cambiar a detección automática?",
        noAnalyticsYet: "No hay estadísticas disponibles todavía",
        noAnalyticsDesc: "Las estadísticas aparecerán cuando recibas respuestas."
    },

    // ==========================================
    // CAMPAIGNS TAB
    // ==========================================
    campaigns: {
        title: "Mensajes a Invitados",
        newCampaign: "Enviar mensajes",
        sendInvitations: "Enviar Invitaciones",
        campaignHistory: "Historial de Mensajes",
        noCampaigns: "¿Listo para invitar a tus invitados?",
        noCampaignsDesc: "Envía invitaciones personalizadas por correo electrónico o WhatsApp. Rastrearemos quién abre y responde.",
        createFirst: "Enviar Invitaciones",
        contactStatus: "Estado de Contactos",
        sendReminder: "Enviar Recordatorio",
        scheduledReminders: "Recordatorios Programados",
        credits: "Créditos",
        buyCredits: "Comprar Créditos",
        messagesSent: "mensajes enviados",
        delivered: "entregados",
        opened: "abiertos",
        clicked: "clics",
        responded: "respondieron",
        pending: "pendientes"
    },

    // ==========================================
    // CAMPAIGN WIZARD
    // ==========================================
    wizard: {
        title: "Enviar Invitaciones",
        step1: "Contactos",
        step2: "Revisar",
        step3: "Enviar",
        addContacts: "Agregar Contactos",
        importFromFile: "Importar desde Archivo",
        pasteContacts: "Pegar Contactos",
        manualEntry: "Entrada Manual",
        uploadCSV: "Subir CSV",
        uploadVCard: "Subir vCard",
        dragDropHere: "Arrastra archivos aquí o haz clic para buscar",
        supportedFormats: "Formatos soportados: CSV, VCF (vCard)",
        contactsAdded: "contactos agregados",
        reviewContacts: "Revisar Contactos",
        removeSelected: "Eliminar Seleccionados",
        selectAll: "Seleccionar Todos",
        deselectAll: "Deseleccionar Todos",
        messageTemplate: "Plantilla de Mensaje",
        personalizeMessage: "Personalizar Mensaje",
        previewMessage: "Vista Previa del Mensaje",
        sendVia: "Enviar por",
        email: "Correo Electrónico",
        whatsapp: "WhatsApp",
        both: "Ambos",
        schedule: "Programar",
        sendNow: "Enviar Ahora",
        scheduleLater: "Programar para Después",
        confirmSend: "Confirmar Envío",
        sending: "Enviando...",
        sent: "Enviado",
        failed: "Error",
        cancel: "Cancelar",
        back: "Atrás",
        next: "Siguiente",
        finish: "Finalizar"
    },

    // ==========================================
    // EXPORT TAB
    // ==========================================
    export: {
        title: "Exportar Datos",
        exportCSV: "Exportar a CSV",
        exportLanguage: "Idioma de Exportación",
        original: "Original (Sin traducir)",
        selectLanguage: "Seleccionar idioma...",
        exportAll: "Exportar Todo",
        exportFiltered: "Exportar Filtrado",
        downloading: "Descargando...",
        downloadComplete: "Descarga completada",
        noDataToExport: "No hay datos para exportar"
    },

    // ==========================================
    // MODALS
    // ==========================================
    modals: {
        editResponse: "Editar Respuesta",
        deleteResponse: "Eliminar invitado",
        confirmDelete: "¿Estás seguro de que deseas eliminar esta respuesta? Esta acción no se puede deshacer.",
        sendReminder: "Enviar Recordatorio Inteligente",
        reminderDesc: "Los destinatarios se filtran según el seguimiento de mensajes.",
        recipients: "Destinatarios",
        customMessage: "Mensaje Personalizado (opcional)",
        customMessagePlaceholder: "Añade una nota personal...",
        scheduledReminders: "Configurar Recordatorios Programados",
        enableReminders: "Habilitar Recordatorios Programados",
        reminderTiming: "Cuándo enviar recordatorios:",
        oneDay: "1 día antes",
        threeDays: "3 días antes",
        oneWeek: "1 semana antes",
        twoWeeks: "2 semanas antes",
        contactStatus: "Estado de Contactos",
        allContacts: "Todos los Contactos",
        respondedFilter: "Respondieron",
        pendingFilter: "Respuesta Pendiente",
        doubleResponse: "Respuesta Doble ⚠️",
        emailStatus: "Estado del Correo",
        whatsappStatus: "Estado de WhatsApp",
        translating: "Traduciendo Respuestas",
        translatingTo: "Traduciendo respuestas a"
    },

    // ==========================================
    // USER EVENTS
    // ==========================================
    events: {
        myEvents: "Mis Eventos",
        noEvents: "No se Encontraron Eventos",
        noEventsDesc: "Aún no has creado ningún formulario RSVP.",
        createFirst: "Crear Tu Primer Evento",
        created: "Creado",
        eventId: "ID del Evento",
        viewResponses: "Ver Respuestas",
        loadingEvents: "Cargando tus eventos...",
        errorLoading: "Error al cargar tus eventos"
    },

    // ==========================================
    // AUTH
    // ==========================================
    auth: {
        signIn: "Iniciar Sesión",
        signInDesc: "Inicia sesión para ver tus formularios",
        signInPrompt: "Inicia sesión para acceder",
        loginWithEmail: "Iniciar sesión con correo electrónico",
        loginWithGoogle: "Continuar con Google",
        loginWithApple: "Continuar con Apple",
        or: "o",
        noAccount: "¿No tienes cuenta?",
        createAccount: "Crear cuenta"
    },

    // ==========================================
    // COMMON
    // ==========================================
    common: {
        loading: "Cargando...",
        save: "Guardar",
        cancel: "Cancelar",
        close: "Cerrar",
        delete: "Eliminar",
        edit: "Editar",
        confirm: "Confirmar",
        send: "Enviar",
        search: "Buscar",
        filter: "Filtrar",
        refresh: "Actualizar",
        backToEvents: "Volver a Mis Eventos",
        backToAccess: "Volver a Opciones de Acceso",
        selectEvent: "Seleccionar un Evento",
        selectEventDesc: "Por favor selecciona un evento específico del menú desplegable arriba.",
        error: "Error",
        success: "Éxito",
        warning: "Advertencia",
        info: "Información",
        guests: "invitados"
    },

    // ==========================================
    // UPGRADE PROMPTS
    // ==========================================
    upgrade: {
        unlockResponses: "Desbloquear Todas las Respuestas",
        freeLimit: "Puedes ver hasta 25 respuestas.",
        upgradeForUnlimited: "Actualiza para visualización ilimitada →",
        upgradeRequired: "Actualización Requerida"
    },

    // ==========================================
    // ANALYTICS INSIGHTS (Dynamic JS Content)
    // ==========================================
    insights: {
        // Pattern Insights
        peakResponseDay: "Día Pico de Respuestas",
        peakResponseTime: "Hora Pico de Respuestas",
        responseMomentum: "Impulso de Respuestas",
        attendanceRate: "Tasa de Asistencia",
        daysUntilEvent: "Días Hasta el Evento",
        eventDay: "Día del Evento",

        // Velocity labels
        pickingUp: "Aumentando",
        slowingDown: "Disminuyendo",
        steadyPace: "Ritmo Constante",
        responsesComing: "Las respuestas están llegando más rápido recientemente",
        responseDecreased: "La tasa de respuestas ha disminuido",
        consistentRate: "Tasa de respuestas consistente",

        // Smart Insights
        excellentResponseRate: "Excelente Tasa de Respuesta",
        lowResponseRate: "Tasa de Respuesta Baja",
        highGuestMultiplier: "Alto Multiplicador de Invitados",
        lowerGuestImpact: "Menor Impacto de Invitados",
        attendanceConcerns: "Preocupaciones de Asistencia",
        strongAttendance: "Fuerte Compromiso de Asistencia",

        // Insight descriptions
        respondedWellAbove: "de invitados respondió - ¡muy por encima del promedio!",
        onlyResponded: "Solo han respondido. Considera enviar recordatorios.",
        guestImpact: "de impacto de invitados - ¡la gente trae acompañantes!",
        ensureVenue: "Asegúrate de que el lugar y catering puedan manejar una asistencia mayor.",
        fewerPlusOnes: "de impacto de invitados sugiere menos acompañantes de lo esperado.",
        encourageCompanions: "Considera animar a los invitados a traer acompañantes.",
        respondentsAttending: "de los encuestados asistirán.",
        investigateBarriers: "Investiga posibles conflictos o problemas con la fecha/lugar del evento.",
        showsStrongInterest: "de tasa de asistencia muestra fuerte interés en tu evento!",

        // Activity insights
        greatMomentum: "¡Gran Impulso!",
        activeResponses: "Respuestas Activas",
        recentActivity: "Actividad Reciente",
        responsesThisWeek: "respuestas esta semana con ritmo acelerado - tu difusión está funcionando",
        responsesLast7Days: "respuestas en los últimos 7 días - buen engagement",
        responseInLast: "respuesta(s) en los últimos 7 días",

        // Prediction
        expectedFinalAttendance: "Asistencia Final Esperada",
        projecting: "Proyectando",
        totalGuests: "invitados totales basado en tendencias actuales",
        highConfidence: "alta confianza",
        moderateConfidence: "confianza moderada",
        earlyEstimate: "estimación temprana",
        getMoreResponses: "Obtén más respuestas para mejorar la precisión",

        // Event countdown
        finalCountdown: "¡Cuenta regresiva final!",
        comingSoon: "Próximamente",
        timeToPrepare: "Hora de preparar",
        daysRemaining: "día(s) restante(s)",
        eventIsToday: "¡Tu evento es hoy!",

        // Additional insights
        highResponseVelocity: "Alta Velocidad de Respuesta",
        responsesLast24h: "respuestas en las últimas 24 horas sugieren fuerte engagement",
        optimalCommunicationDay: "Día Óptimo de Comunicación",
        showsResponses: "muestra",
        ofResponses: "de respuestas - ideal para seguimientos",
        scheduleRemindersOn: "Programa recordatorios futuros para máxima tasa de respuesta",
        slowResponseCollection: "Recolección Lenta de Respuestas",
        averagingResponses: "Promediando",
        responsesPerDay: "respuestas por día en",
        days: "días",
        considerDeadline: "Considera mensajes de urgencia o incentivos para acelerar respuestas",
        timeForFollowUp: "Hora de un Seguimiento",
        noResponsesIn: "Sin respuestas en",
        reminderCouldBoost: "días - un recordatorio podría impulsar el engagement",

        // Engagement insights
        highDetailEngagement: "Alto Engagement de Detalles",
        providedDietary: "proporcionó información dietética - invitados muy comprometidos",
        groupEventPattern: "Patrón de Evento Grupal",
        bringingPeople: "Los invitados traen",
        peopleOnAverage: "personas en promedio - planifica para grupos",
        ensureSeating: "Asegura espacio y catering para tamaños de grupo",
        lowFieldCompletion: "Baja Completación de Campos",
        hasLowCompletion: "tiene baja completación",
        haveLowCompletion: "tienen baja completación",
        considerRequired: "Considera hacer campos clave obligatorios",

        // Final week
        finalWeekPush: "Empujón de Última Semana Necesario",
        eventIn: "Evento en",
        daysWithOnly: "días con solo",
        responseRateLabel: "tasa de respuesta",
        attendanceRateLabel: "tasa de asistencia",
        sendUrgentReminder: "Envía recordatorio urgente final para maximizar confirmaciones",
        finalPlanningWindow: "Ventana Final de Planificación",
        daysLeft: "días restantes - hora de conteo final y logística",
        finalizeCatering: "Finaliza cantidades de catering y envía detalles a invitados confirmados",
        timeForFollowUp: "Hora de un Seguimiento",

        // Chart Labels
        adults: "Adultos",
        children: "Niños",
        guests: "Invitados",
        dietary: "Requisitos Dietéticos",
        relationship: "Relación",
        attending: "Asistirán",
        maybe: "Tal vez",
        notAttending: "No Asistirán",
        noResponse: "Sin Respuesta",

        // Activity
        someone: "Alguien",
        confirmedAttendance: "confirmó asistencia",
        declined: "declinó",
        fromBulk: "de masivos",
        manual: "manual",
        fromBulkMessaging: "de mensajería masiva",
        clickToAdjust: "Clic para ajustar",
        sendBulkToUnlock: "Envía mensajes masivos para desbloquear esta métrica",
        guestsConfirmed: "invitados confirmados de",
        invitations: "invitaciones",
        day: "día",
        untilEvent: "hasta el evento",

        // Saturation
        responseSaturation: "Saturación de Respuestas Alcanzada",
        patternSuggests: "El patrón sugiere que has capturado la mayoría de respuestas disponibles",

        // Chart labels
        attending: "Asistirán",
        notAttending: "No Asistirán",
        noResponse: "Sin Respuesta",

        // Live Activity
        liveUpdates: "Actualizaciones en Vivo",
        live: "En Vivo",
        reached: "¡Se alcanzaron",
        responses: "respuestas!",
        latest: "Reciente",

        // Day names
        sunday: "Domingo",
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",

        // Time ranges
        morning: "Mañana (6AM-12PM)",
        afternoon: "Tarde (12PM-6PM)",
        evening: "Noche (6PM-10PM)",
        night: "Madrugada (10PM-6AM)",

        // Yes/No/Maybe
        yes: "sí",
        no: "no",
        maybe: "quizás",

        // Smart insights empty state
        smartInsightsWillAppear: "Los insights inteligentes aparecerán cuando lleguen más respuestas..."
    },

    // ==========================================
    // BULK SHARING WIZARD (Full UI)
    // ==========================================
    bulkWizard: {
        // Builder-mount success screen (first send from the Share step).
        remindersOnDashboard: "Los recordatorios, el estado de entrega y los seguimientos están en tu panel.",
        goToDashboard: "Abrir panel",
        outcomeScheduledTitle: "Mensaje programado",
        outcomeScheduledBody: "Tu mensaje se enviará el {date}.",
        outcomeApprovalTitle: "Esperando la aprobación de WhatsApp",
        outcomeApprovalBody: "WhatsApp revisa cada mensaje nuevo antes de enviarlo, normalmente en pocos minutos. Tus invitados de WhatsApp lo recibirán en cuanto se apruebe y no tienes que hacer nada más.",
        outcomeApprovalOthersSent: "Los invitados que lo reciben por correo electrónico o SMS ya lo están recibiendo.",
        outcomeHeldTitle: "Estamos revisando tu primer mensaje",
        outcomeHeldBody: "Es una revisión única del primer envío. Te escribiremos en cuanto se libere. No se ha enviado nada ni se han usado créditos.",
        outcomeRefusedTitle: "WhatsApp no aceptó este mensaje",
        outcomeRefusedReason: "Motivo de WhatsApp: {reason}",
        outcomeRefusedOthersNow: "Los invitados que lo reciben por correo electrónico o SMS lo siguen recibiendo.",
        outcomeRefusedOthersScheduled: "Los invitados que lo reciben por correo electrónico o SMS lo recibirán igualmente el {date}.",
        outcomeRefusedNoOthers: "Todavía no se ha enviado a ninguno de tus invitados.",
        outcomeRefusedFix: "Para llegar a tus invitados de WhatsApp, edita el mensaje desde tu panel y vuelve a enviarlo. WhatsApp revisará el nuevo texto.",
        tplErr_trailingParam: "Tu mensaje no puede TERMINAR con una etiqueta de personalización como {{name}} o {{table_number}}. WhatsApp no lo permite. Pon una palabra o un punto después de la etiqueta y vuelve a enviarlo.",
        tplErr_waLink: "WhatsApp no permite un botón que enlace de vuelta a WhatsApp. Haz que ese botón lleve a otro sitio y vuelve a enviarlo.",
        tplErr_imageFormat: "Para WhatsApp, la imagen de tu invitación tiene que ser JPG o PNG. Vuelve a subirla en ese formato y reenvíala.",
        tplErr_imageProcess: "WhatsApp no pudo procesar la imagen de tu invitación. Prueba con otra (JPG o PNG, de menos de 5 MB) y vuelve a enviarlo.",
        tplErr_category: "WhatsApp considera tu mensaje de un tipo distinto al que le asignamos. Vuelve a enviarlo y debería pasar.",
        tplErr_layout: "WhatsApp no pudo leer el formato de tu mensaje. Suele ser una {{etiqueta}} sola en su propia línea. Ponla dentro de una frase y vuelve a enviarlo.",
        tplErr_duplicateName: "WhatsApp ya tiene un mensaje guardado con este nombre. Cambia el nombre del mensaje y vuelve a enviarlo.",
        tplErr_rateLimit: "Has llegado por ahora al límite de mensajes nuevos de WhatsApp. Espera un poco y vuelve a enviarlo. No se pierde nada.",
        outcomeSubmitFailedTitle: "Todavía no hemos podido enviar tu mensaje a WhatsApp para su aprobación",
        close: "Cerrar",
        outcomeSubmitFailedBody: "Lo seguiremos intentando automáticamente y te escribiremos si WhatsApp lo rechaza. Por ahora no tienes que hacer nada.",
        outcomeVerifyTitle: "Confirma tu correo electrónico para enviarlo",
        outcomeVerifyBody: "Tu mensaje está guardado, pero todavía no se ha enviado nada. Confirma tu dirección de correo electrónico (en la pestaña Compartir de tu formulario) y se enviará automáticamente.",
        outcomeUpgradeTitle: "Hace falta mejorar el plan antes de enviarlo",
        outcomeUpgradeBody: "Este evento usa funciones de su plantilla que requieren mejorar el plan. Mejóralo desde su panel y tu mensaje se enviará automáticamente. Todavía no se ha enviado nada.",
        outcomePausedTitle: "Tu mensaje todavía no se ha enviado",
        outcomePausedBody: "Está guardado, pero todavía no se ha enviado nada. Puedes ver su estado en tu panel.",
        sendBlockedBlanks: "Tu mensaje todavía tiene espacios de la plantilla por completar: {blanks}",
        sendDateMissing: "Elige una fecha para tu mensaje programado.",
        sendDatePast: "La fecha y hora programadas ya pasaron. Elige un momento futuro.",
        // Initial loading
        checkingAccess: "Verificando permisos de acceso...",
        wizardFailedToLoad: "El asistente de mensajes no pudo cargarse. Por favor, actualiza la página.",

        // Progress steps
        step1Contacts: "1. Contactos",
        step2Channels: "2. Canales",
        step2Review: "3. Personalizar",
        step3FollowUp: "4. Seguimiento",
        step4Send: "5. Enviar",

        // Navigation buttons
        previous: "Anterior",
        next: "Siguiente",
        nextChannels: "Siguiente: Canales de envío",
        nextCustomize: "Siguiente: Personalizar",
        nextFinalize: "Siguiente: Finalizar y Enviar",
        skip: "Omitir",
        saveAsDraft: "Guardar Borrador",

        // Contacts step
        uploadContactList: "Subir Lista de Contactos",
        uploadContactsDesc: "Sube contactos en formato CSV o vCard",
        dragDropFile: "Arrastra y Suelta Archivo",
        orClickToBrowse: "o haz clic para buscar",
        chooseFile: "Elegir Archivo",
        csvOrVcard: "CSV o vCard (.vcf)",
        manuallyAddContacts: "Agregar Contactos Manualmente",
        csvTemplate: "Plantilla CSV",
        vcardTemplate: "Plantilla vCard",

        // Phone tip
        phoneTip: "Los números de teléfono deben incluir el código de país (ej., +15551234567). Si usas Excel, formatea la columna como \"Texto\" para evitar problemas de formato.",

        // Sending method
        sendVia: "Enviar Por",
        channelEmail: "Correo Electrónico",
        channelEmailTooltip: "Enviar por correo electrónico. Si no hay correo, se usará móvil.",
        channelMobile: "Móvil (WhatsApp/SMS)",
        channelMobileTooltip: "Enviar por WhatsApp, con SMS como respaldo. Si no hay teléfono, se usará correo.",
        channelHint: "1 crédito por canal. El sistema cambia a otros canales si falla la entrega.",
        deliveryMethod: "Método de envío",
        smartDeliveryLabel: "Envío inteligente",
        smartDeliveryShortDesc: "WhatsApp/SMS cuando esté disponible, correo electrónico en caso contrario.",
        smartDeliveryCreditNote: "1 crédito por contacto.",
        customizeDelivery: "Personalizar",
        channelsStepTitle: "Revisa los canales de envío",
        channelsStepSubtitle: "Elige cómo recibirán tus invitados esta invitación.",
        usNumbersDeliveryNote: "🇺🇸 Nota sobre números de EE. UU.: Meta no permite el envío masivo de WhatsApp a números de EE. UU., por lo que se enviarán automáticamente por SMS estándar. Los números de Canadá también empiezan por +1, pero no se ven afectados: reciben WhatsApp. Si tus invitados con números de EE. UU. están actualmente en el extranjero, te recomendamos añadir una dirección de correo electrónico para garantizar la entrega.",
        deliveryModalTitle: "¿Cómo quieres enviar?",
        deliveryOptionSmart: "Envío inteligente",
        deliveryOptionSmartTag: "Recomendado",
        deliveryOptionSmartDesc: "WhatsApp para contactos fuera de EE.UU., SMS para contactos en EE.UU., y correo electrónico para contactos sin teléfono. 1 crédito por contacto.",
        deliveryOptionEmail: "Correo primero",
        deliveryOptionEmailDesc: "Prioriza el envío por correo electrónico. Usa el móvil automáticamente si no se proporciona un correo.",
        deliveryOptionMobile: "Móvil primero",
        deliveryOptionMobileDesc: "Prioriza el envío por móvil (WhatsApp/SMS). Usa el correo automáticamente si no se proporciona un teléfono.",
        deliveryOptionBoth: "Ambos canales",
        deliveryOptionBothDesc: "Enviar tanto por correo como por móvil cuando ambos estén disponibles.",
        deliveryOptionBothCost: "1 crédito por contacto, incluso con ambos canales.",
        deliveryDoneBtn: "Guardar",
        deliveryCancelBtn: "Cancelar",
        usWhatsappShortNotice: "WhatsApp masivo no está permitido para números de EE.UU. (política de Meta).",

        // SMS consent
        consentNotice: "Tus invitados pueden incurrir en tarifas de mensajes y datos (la frecuencia varía) y pueden responder STOP para cancelar, HELP para ayuda.",
        usWhatsappNotice: "Según la política actual de Meta, los números de teléfono de EE.UU. no pueden recibir mensajes masivos de WhatsApp y cambiarán automáticamente a SMS. Aún puedes enviar mensajes a números de EE.UU. individualmente por WhatsApp.",
        smsConsentCheckbox: "Confirmo que todos los destinatarios han dado su consentimiento para recibir mensajes SMS de invitación a mi evento a través de QuikRSVP.",
        smsConsentDisclosure: "Los destinatarios pueden responder STOP para cancelar o HELP para asistencia. Pueden aplicar tarifas de datos y mensajes. La frecuencia varía.",
        smsConsentRequired: "Debes confirmar el consentimiento del destinatario antes de enviar.",
        termsConsentRequired: "Debes aceptar los Términos y Condiciones y la Política de Privacidad antes de enviar.",
        smsConsentEmailFallbackHint: "No hay correo electrónico para {n} de tus invitados, así que el mensaje se enviará a su teléfono, posiblemente como SMS.",
        smsConsentEditTitle: "Confirma el consentimiento para SMS",
        smsConsentEditBody: "Algunos invitados de este mensaje tienen números de EE. UU., otros números +1 o números de Brasil, así que pueden recibirlo por SMS. Confirma su consentimiento para guardar los cambios.",
        smsConsentEditSave: "Confirmar y guardar",
        termsLink: "Términos y Condiciones",
        privacyLink: "Política de Privacidad",

        // Contact summary
        valid: "válidos",
        invalid: "inválidos",
        messages: "mensajes",
        editContacts: "Editar Contactos",
        invalidContacts: "Contactos Inválidos:",

        // Follow-up banner
        followUpCampaign: "Mensaje de Seguimiento",
        contactsAutoLoaded: "contactos se han cargado automáticamente de tu mensaje anterior.",
        filterApplied: "Filtro aplicado:",
        startFresh: "Empezar de Nuevo",

        // File parsing
        dragDropCsv: "Arrastra y suelta archivo CSV aquí o haz clic para buscar",
        dragDropVcard: "Arrastra y suelta archivo vCard aquí o haz clic para buscar",
        csvColumns: "Columnas: Nombre(s) de invitados, Nombre del grupo, Teléfono, Correo (opcionales: Máx. invitados, Etiquetas)",
        downloadCsvTemplate: "Descargar Plantilla CSV",
        downloadVcardTemplate: "Descargar Plantilla vCard",
        vcardFromSources: "Archivo .vcf estándar de fuentes como Google Contacts o Outlook.",

        // Send step
        readyToSend: "¡Listo para Enviar!",
        reviewAndSend: "Revisa los detalles de tu mensaje y envía tus invitaciones.",
        campaignSummary: "Resumen del Mensaje",
        totalMessages: "Total de Mensajes",
        emailLabel: "Correo Electrónico",
        mobileLabel: "Móvil",

        // Reminders
        remindersEnabled: "Recordatorios Activados:",

        // Credits
        messageCredits: "Créditos de Mensajes",
        yourBalance: "Tu Saldo",
        creditsNeeded: "Créditos Necesarios",
        readyToSendCredits: "¡Listo para enviar! Tienes suficientes créditos para este mensaje.",
        needMoreCredits: "Necesitas más créditos.",
        purchasePackage: "Compra un paquete para continuar.",

        // Send timing
        sendTiming: "Programación de Envío",
        sendImmediately: "Enviar Inmediatamente",
        messagesQueuedNow: "Los mensajes se pondrán en cola de inmediato",
        scheduleForLater: "Programar para Después",
        chooseDateTime: "Elige una fecha y hora específica",
        date: "Fecha",
        time: "Hora",
        schedulingNote: "La hora de entrega es aproximada y no está garantizada. Los mensajes se pondrán en cola para procesamiento a la hora programada.",

        // Buttons
        sendCampaign: "Enviar a los invitados",
        upgradeAndBuyCredits: "Actualizar y Comprar Créditos",
        buyCredits: "Comprar Créditos",

        // Credits info
        creditsInfo: "Los créditos se cuentan por invitado, no por mensaje • Los créditos nunca expiran • Funcionan en todos los formularios",
        // Send step: guests per channel and the one cost line (_deliveryPlanHtml).
        deliveryPlanTitle: "Cómo lo recibirán tus invitados",
        deliveryWhatsapp: "WhatsApp",
        deliverySms: "Mensaje de texto (SMS)",
        deliveryEmail: "Correo electrónico",
        deliveryGuestsOne: "1 invitado",
        deliveryGuestsMany: "{n} invitados",
        deliveryFullDesc: "Tu mensaje completo, con la imagen y los botones que hayas añadido",
        deliverySmsDesc: "Solo texto: sin imagen ni botones. Tus enlaces se envían como direcciones web.",
        deliverySmsDescNoLink: "Solo texto: sin imagen, botones ni enlaces.",
        deliverySmsWhy: "Los números de EE. UU. reciben un SMS porque WhatsApp no entrega invitaciones como esta a números de EE. UU.",
        deliverySmsPreview: "Ver el SMS que recibirán",
        deliverySmsCantSend: "Estos invitados no recibirán un SMS: un SMS solo admite letras latinas y este mensaje no tiene ninguna. Añade una versión en inglés de tu mensaje en el paso Personalizar para llegar a ellos.",
        deliverySmsEmailOnlyOne: "1 de ellos tiene correo electrónico y solo recibirá el correo.",
        deliverySmsEmailOnlyMany: "{n} de ellos tienen correo electrónico y solo recibirán el correo.",
        deliverySmsNothingOne: "1 invitado no recibirá nada.",
        deliverySmsNothingMany: "{n} invitados no recibirán nada.",
        costLabel: "Precio",
        costCreditsOne: "1 crédito",
        costCreditsMany: "{n} créditos",
        costPerGuest: "1 crédito por invitado",
        costPerGuestTicketed: "1 crédito por invitado que lo recibe en el teléfono; los correos son gratis en los eventos con entradas",
        balanceAfterSending: "Saldo tras el envío: {n}",
        costUnsentNote: "Los créditos reservados para los invitados que no reciban nada se te devuelven tras el envío.",
        remindersCostNote: "Cada recordatorio cuesta 1 crédito por invitado al que llega, cuando se envía.",
        remindersCostNoteTicketed: "Cada recordatorio cuesta 1 crédito por invitado al que llega por teléfono, cuando se envía. Los correos son gratis.",
        notEnoughCreditsToSend: "No tienes créditos suficientes: tienes {balance} y este mensaje necesita {needed}. Compra más créditos y vuelve a enviarlo.",

        // Contact editor modal
        contactEditor: "Editor de Contactos",
        name: "Nombre",
        email: "Correo electrónico",
        phone: "Teléfono",
        actions: "Acciones",
        addNewContact: "Agregar Nuevo Contacto",
        saveContacts: "Guardar Contactos",
        cancel: "Cancelar",

        // Validation
        contactsCleared: "Contactos eliminados. Ahora puedes subir una nueva lista de contactos.",

        // Review step labels
        composeYourMessage: "Componer tu Mensaje",
        composeSubtitle: "Personaliza tu invitación y elige cómo la recibirán los invitados.",
        messageAndTranslations: "Mensaje y traducciones",
        customEmailSettings: "Configuración de correo",
        buttonsLinks: "Botones y Enlaces",
        linksButtonsLabel: "Enlaces / botones",
        buttonsLinksHint: "Elige hasta 2 botones para incluir en tu mensaje.",
        campaignButtonsMax: "Puedes incluir hasta 2 botones por mensaje",
        buttonCaptionAlsoIn: "También se envía en {n}",
        buttonCaptionAsTyped: "Tu texto — se envía tal cual",
        buttonCaptionPairTip: "Los dos idiomas van juntos en el botón. Si el par supera los 25 caracteres que permite WhatsApp, se queda en uno solo — mira la vista previa para ver el texto exacto.",
        buttonLabelOptional: "Texto del botón (opcional)",
        buttonAppearsOn: "Los botones aparecen en WhatsApp y en el email.",
        rsvpTargetLabel: "¿A dónde debe dirigir el enlace de confirmación?",
        rsvpTargetForm: "Formulario QuikRSVP",
        rsvpTargetWebsite: "Mi sitio web de boda",
        campaignName: "Nombre del mensaje",
        campaignNamePlaceholder: "Nombra tu mensaje…",
            campaignNameDefaultDescriptor: "Invitaciones",
        campaignNameHelp: "Dale un nombre a este mensaje para identificarlo después",
        campaignNameDuplicate: "Ya existe un mensaje con este nombre. Elige un nombre único (por ejemplo, añade « - Grupo B »), o agrega contactos a tu mensaje existente.",
        campaignNameDupShort: "Ya existe un mensaje con este nombre.",
        campaignNameDupViewExisting: "Ver mensaje existente",
        emailSubjectLine: "Asunto del Correo",
        emailSenderName: "Nombre del Remitente",
        emailSenderNameHelp: "Nombre que ven los invitados",
        replyToLabel: "Las respuestas llegan a",
        replyToDefaultSuffix: "predeterminada",
        replyToAddOption: "Usar otra dirección…",
        replyToNewPlaceholder: "nombre@ejemplo.com",
        replyToSendVerify: "Enviar confirmación",
        replyToSending: "Enviando…",
        replyToSent: "Confirmación enviada. Abre esa bandeja, haz clic en el enlace y luego elige la dirección aquí.",
        replyToRecheck: "Ya la confirmé",
        replyToAlreadyVerified: "Esa dirección ya está confirmada: elígela en la lista.",
        replyToInvalid: "Introduce una dirección de correo válida.",
        replyToError: "No se pudo enviar la confirmación. Inténtalo de nuevo.",
        replyToWhyVerify: "Confirmamos la dirección primero para que las invitaciones no puedan dirigir las respuestas a un buzón que el remitente no controla.",
        emailThemeColor: "Color del Correo",
        emailLogo: "Logo del Correo",
        emailLogoUpload: "Subir",
        emailLogoHide: "Ocultar",
        emailLogoShow: "Mostrar",
        emailLogoReset: "Usar el logo de QuikRSVP",
        emailLogoPaidOnly: "Planes de pago",
        emailLogoUpgradeMsg: "El logo personalizado está disponible en los planes de pago — mejora tu formulario para personalizarlo.",
        messageHeader: "Encabezado de Invitación",
        messageHeaderHelp: "Título en negrita en la parte superior de tu email y WhatsApp. Elimínalo para ocultarlo.",
        invitationTagline: "Subtítulo de Invitación",
        invitationTaglineHelp: "Texto más pequeño debajo del encabezado (p. ej., \"Estás Invitado\"). Elimínalo para ocultarlo. (solo correo)",
        headerAndSubject: "Título, Subtítulo y Asunto",
        leaveBlankToHide: "Deja en blanco para ocultar",
        yourMessage: "Tu Mensaje",
        writeMessagePlaceholder: "Escribe tu mensaje de invitación aquí...",
        characters: "caracteres",
        translateTo: "Traducir a:",
        translate: "Traducir",
        translationWillAppear: "La traducción aparecerá aquí...",
        // Message & Translations block (task #453)
        translateHint: "Envía esta invitación en otro idioma",
        translationsReady: "Traducciones listas",
        messageLanguages: "Idiomas del mensaje",
        yourMessageBadge: "Tu mensaje",
        hide: "Ocultar",
        view: "Ver",
        addAnotherLanguage: "Añadir otro idioma",
        chooseLanguage: "Elegir…",
        willSendAsWritten: "Los invitados reciben {a}: el mensaje tal como lo escribiste",
        willSendTranslationOnly: "Los invitados reciben solo {a}; tu original no se envía",
        willSendBoth: "Los invitados reciben {a} y {b} juntos en un mismo mensaje",
        oneTranslationOnly: "Un mensaje lleva tu original más una traducción. Desmarca {lang} primero.",
        pickAtLeastOneLanguage: "Elige al menos un idioma para enviar.",
        addLanguageToTranslate: "Elige un idioma al que traducir.",
        emptyLanguageBlocked: "Añade texto para {langs} o desmarca el idioma.",
        emptyLanguagesBlocked: "Añade texto para estos idiomas o desmárcalos: {langs}.",
        smsNotSendable: "no se puede enviar por SMS",
        smsSourceOnly: "El SMS envía solo tu original",
        smsSendsTranslation: "El SMS envía tu traducción en su lugar",
        waCombinedOver: "Ambos idiomas comparten un solo mensaje de WhatsApp: {n} de 1.024 caracteres. Acorta uno.",
        bothWillBeSent: "Se enviarán tanto el original como la traducción",
        onlyTranslationWillBeSent: "Solo se enviará esta traducción",
        sendAsWrittenDesc: "El mensaje ya está en el idioma que los invitados deben recibir",
        sendTranslatedOnly: "Enviar solo la versión traducida",
        bilingual: "Bilingüe",
        sendBilingual: "Enviar ambos, original y traducción en un mensaje",
        multiLanguageHint: "¿Necesitas contactar invitados en diferentes idiomas por separado? Crea un mensaje para cada idioma.",
        preview: "Vista Previa",
        addImage: "Agregar Imagen",
        changeImage: "Cambiar Imagen",
        convertingImage: "Convirtiendo la foto de iPhone…",
        processingImage: "Procesando la imagen…",
        uploadingImage: "Subiendo…",
        invitationImage: "Imagen de la invitación",
        invitationImageDesc: "Opcional — se muestra en la parte superior de tu correo y mensaje de WhatsApp.",
        invitationSplashLabel: "Abrir en pantalla completa al tocar",
        invitationSplashDesc: "Los invitados que toquen tu invitación en WhatsApp la verán en grande y luego tu formulario de confirmación.",
        beforeYouSend: "Antes de enviar",
        goodToKnow: "Notas sobre créditos y entrega",
        optionalLabel: "opcional",
        csvFormattingTips: "Consejos de formato CSV",
        downloadTemplate: "Descargar plantilla",
        previewShowsExactly: "La vista previa muestra exactamente lo que recibirán los invitados.",

        // What happens next
        whatHappensNext: "¿Qué Sucede Después?",

        // Success states
        campaignCreated: "¡Mensaje Creado!",
        messagesQueued: "mensajes en cola para entrega",
        scheduledFor: "Programado para",
        tip: "Consejo",

        // Follow-up reminders step
        followUpRemindersTitle: "Recordatorios de Seguimiento",
        followUpRemindersDesc: "Programa recordatorios automáticos para tus invitados",
        saveAndResubmitWhatsApp: "Guardar y reenviar a WhatsApp",
        saveAndResend: "Guardar y reenviar",
        saveAndResubmitHint: "Envía tu mensaje editado de nuevo a WhatsApp para su aprobación. Después llegará a los invitados que nunca lo recibieron.",
        saveAndResendHint: "Guarda tu mensaje editado y lo envía a los invitados que nunca lo recibieron.",
        // Edit & Resend feedback: the save is instant, the WhatsApp
        // re-submission is not, so they are reported separately (task #592).
        editSavedChanges: "Cambios guardados.",
        editSavedResubmitting: "Cambios guardados. Enviando tu mensaje a WhatsApp para su aprobación…",
        translationStale: "Tu mensaje cambió después de traducirse. Actualiza la traducción.",
        translateAgain: "Traducir de nuevo",
        translationStaleBlocked: "Cambiaste tu mensaje después de traducirlo. Actualiza la traducción al {lang} antes de enviar: pulsa Traducir de nuevo o edítala a mano.",
        translationStaleWarn: "Cambiaste tu mensaje después de traducirlo. Comprueba que la traducción al {lang} sigue coincidiendo.",
        editSavedRescheduled: "Cambios guardados. Tu mensaje se enviará el {date}.",
        editTimingUseSend: "Cambios guardados. Tu mensaje sigue programado para el {date}. Para enviarlo ahora, pulsa Enviar.",
        editSavedNotSent: "Cambios guardados. Todavía no se ha enviado nada. Para enviarlo, abre Editar y reenviar y pulsa Enviar.",
        editSavedRescheduledPaused: "Cambios guardados. La nueva hora es el {date}. El mensaje seguirá en pausa hasta que lo reanudes.",
        editTimingAfterReminder: "Hay un recordatorio de este mensaje programado para el {date}. Elige una hora anterior o cambia antes el recordatorio.",
        editTimingPast: "Esa hora ya ha pasado. Elige una hora futura.",
        editTimingPickDate: "Elige una fecha y hora para el envío programado.",
        editResubmitAccepted: "Tu mensaje editado está en WhatsApp a la espera de aprobación. Se enviará en cuanto lo aprueben.",
        editResubmitRefused: "WhatsApp no aceptó el mensaje",
        sendTestSavedAsDraft: "Tu mensaje se guardó como borrador para poder enviar esta prueba: lo encontrarás en tu lista de mensajes.",
        editBlockedSending: "No se guardaron tus cambios: este mensaje empezó a enviarse. Cuando termine, añade a los invitados nuevos con «Añadir contactos» en su tarjeta.",
        editBlockedStale: "No se guardaron tus cambios: este mensaje cambió mientras lo editabas (por ejemplo, se añadieron invitados o se envió). Cierra esta ventana y vuelve a abrirlo para editar la versión más reciente.",
        nextFollowUp: "Siguiente: Seguimiento",
        addAnotherReminder: "Agregar un Recordatorio",
        removeReminder: "Eliminar",
        reminderNumber: "Recordatorio",
        whenToSend: "Cuándo enviar",
        sendTo: "A quién enviar",
        reminderMessage: "Mensaje",
        reminderButtonsLabel: "Botones",
        reminderButtonRsvp: "Confirmación de asistencia",
        reminderRsvpAutoIncluded: "(enlace incluido automáticamente)",
        reminderButtonRegistry: "Mesa de regalos",
        reminderButtonDirections: "Cómo llegar",
        reminderButtonWebsite: "Sitio web de la boda",
        reminderButtonsHint: "Los botones son opcionales: añade hasta 2 o déjalos sin marcar para enviar un recordatorio de solo texto.",
        reminderButtonLabelLangHint: "Si lo dejas en blanco, cada botón aparece en ambos idiomas, como se muestra. Un texto que escribas se envía tal cual — escribe los dos idiomas si quieres ambos.",
        reminderEditButton: "Editar",
        reminderEditTitle: "Editar recordatorio",
        reminderNewTitle: "Nuevo recordatorio",
        reminderLinkedNote: "Se envía como recordatorio vinculado a \"{name}\", no como un mensaje nuevo.",
        reminderRecipientsFinalized: "Los destinatarios se definen cuando se envía el recordatorio.",
        reminderFixedRecipientsNote: "Este recordatorio se enviará a los {count} destinatarios que seleccionaste.",
        reminderAudienceScopeNote: "Este seguimiento se enviará <strong>solo</strong> a los destinatarios de este mensaje específico, no a todos los invitados de tu evento.",
        reminderSendNowHint: "Por defecto se envía ahora: saldrá en breve (cuando WhatsApp apruebe el mensaje). Elige una fecha y hora posteriores para programarlo.",
        reminderCancel: "Cancelar",
        reminderSaveChanges: "Guardar cambios",
        reminderCreateBtn: "Crear recordatorio",
        reminderReviewContinue: "Continuar",
        reminderReviewPreviewNote: "Quien quites aquí solo quedará fuera de este recordatorio; tus otros recordatorios no cambian. El resto de la lista se confirma al enviarse — por ejemplo, los invitados que respondan antes se omiten automáticamente.",
        removeButton: "Quitar",
        linkChipUrlLabel: "Enlace",
        linkChipLabelLabel: "Texto del botón",
        linkChipSave: "Añadir",
        linkChipUrlRequired: "Añade un enlace o cancela.",
        remindAllTitle: "Enviar un recordatorio",
        remindAllSubtitle: "{n} destinatarios",
        remindAllPreConfigure: "Ahora mismo no hay invitados que coincidan: este recordatorio se enviará automáticamente a quienes coincidan en el momento del envío.",
        remindAllSendingTo: "Enviando a <strong>{n}</strong> invitado(s) seleccionado(s).",
        remindAllAddedOptedOut: "{n} invitado(s) que agregaste tienen los recordatorios desactivados para este evento, así que no recibirán este.",
        remindAllContinue: "Continuar al envío",
        remindAllNextStepHint: "Elegirás cómo se envía y confirmarás el costo en el siguiente paso.",
        reminderUpdatedToast: "Recordatorio actualizado",
        reminderResubmittedToast: "Recordatorio actualizado y reenviado a WhatsApp para su aprobación.",
        reminderCreatedToast: "Recordatorio creado: se enviará a la hora programada.",
        reminderSendingNowToast: "Tu recordatorio está en camino — se está enviando ahora.",
        reminderUpdateFailed: "No se pudo actualizar el recordatorio: ",
        reminderCreateFailed: "No se pudo crear el recordatorio: ",
        reminderAlertPickDateTime: "Elige una fecha y hora de envío.",
        reminderAlertTrailingTag: "Tu mensaje no puede terminar con una etiqueta de personalización como {{table_number}} — WhatsApp no lo permite. Añade unas palabras después (p. ej., \"¡Nos vemos allí!\").",
        reminderAlertValidDateTime: "Introduce una fecha y hora válidas.",
        reminderAlertRegistryUrl: "Añade una URL para el enlace de la mesa de regalos o desmárcalo.",
        reminderAlertDirectionsUrl: "Añade una URL para el enlace de cómo llegar o desmárcalo.",
        reminderAlertWebsiteUrl: "Añade una URL para el enlace del sitio web de la boda o desmárcalo.",
        reminderAlertLivestreamUrl: "Agrega un enlace para la transmisión en vivo o desmárcala.",
        reminderSendNowChoice: "Enviar ahora",
        reminderScheduleChoice: "Programar para más tarde",
        reminderGoesOutShortly: "Tu recordatorio saldrá en breve (cuando WhatsApp apruebe el mensaje).",
        reminderHourOnlyHint: "Los recordatorios se envían en punto (no se usan los minutos).",
        reminderIncludeImage: "Incluir la foto de la invitación",
        reminderImageHeading: "Imagen",
        reminderTranslateLabel: "También enviar una traducción al {lang}",
        reminderTranslateHint: "Desactivado por defecto: tu recordatorio se envía tal como lo escribiste. Actívalo para traducirlo y añadirlo automáticamente.",
        useDifferentLink: "Usar otro enlace…",
        reminderIncludeThisImage: "Incluir esta imagen",
        reminderUseDifferentImage: "Usar otra imagen",
        reminderCustomImageNote: "Este recordatorio usa una imagen diferente a la de la invitación.",
        reminderButtonsMax: "Puedes incluir hasta 2 botones por recordatorio.",
        reminderButtonUrlPlaceholder: "Pega un enlace (https://...)",
        invalidButtonUrlWarning: "Esto no parece un enlace web válido. Si es una dirección, pega el enlace de Google Maps — los enlaces no válidos se omiten en los mensajes de WhatsApp.",
        reminderDirectionsUrlPlaceholder: "Enlace de Google Maps o Waze",
        reminderButtonUrlMissing: "Agrega un enlace para el botón seleccionado o deselecciónalo.",
        resetToDefault: "Restablecer predeterminado",
        guestsWhoHaventRSVPd: "Invitados que no han confirmado",
        attendingGuests: "Invitados que asistirán",
        allGuests: "Todos los invitados",
        guestsAnsweredMaybe: "Invitados que respondieron «Quizás»",
        guestsDeclined: "Invitados que respondieron «No»",
        twoWeeksBefore: "2 semanas antes del evento",
        oneWeekBefore: "1 semana antes del evento",
        threeDaysBefore: "3 días antes del evento",
        oneDayBefore: "1 día antes del evento",
        dayOfEvent: "El día del evento",
        oneDayAfter: "El día después del evento",
        threeDaysAfter: "3 días después del evento",
        reminderButtonAlbum: "Álbum de fotos de invitados",
        reminderButtonLivestream: "Transmisión en vivo",
        reminderLivestreamUrlPlaceholder: "Enlace de YouTube, Zoom o Facebook Live",
        reminderAlbumOff: "Activa el álbum en la pestaña «Fotos de invitados» para obtener su enlace.",
        customDate: "Fecha personalizada",
        pickReminderDate: "Elige una fecha",
        reminderTime: "Hora",
        reminderTimeHint: "Se envía a esta hora, según tu zona horaria local.",
        guestNightWarning: "Aviso: muchos de tus invitados lo recibirán de noche (sobre las {time}, hora de ellos). Se enviará igualmente a la hora que elegiste, pero de día se suele responder antes.",
        reminderTimePast: "Elige una fecha y una hora futuras para tu recordatorio personalizado",
        reminderDateInvalid: "La fecha del recordatorio debe ser anterior o igual a la fecha del evento",
        reminderDateMissing: "Por favor, elige una fecha para tu recordatorio personalizado",
        reminderNoEventDate: "Tu evento aún no tiene fecha, así que un recordatorio solo puede enviarse en una fecha que elijas. Elige \"Fecha personalizada\" o añade la fecha del evento en el editor para programar los recordatorios a partir de ella.",
        reminderAfterRsvpDeadline: "Las confirmaciones se cierran antes de que toque este recordatorio, así que no se enviará. Cambia el plazo para confirmar en el editor, elige una hora anterior o quita el enlace de confirmación.",
        defaultReminderMessage: "¡Hola! Solo un recordatorio amigable — ¡nos encantaría saber de ti! Por favor confirma tu asistencia cuando puedas.",
        defaultAttendingMessage: "¡Esperamos verte! Aquí tienes un recordatorio rápido sobre los detalles del evento.",
        defaultMaybeMessage: "¡Hola! Nos dijiste que quizás asistirías — ¿ya lo decidiste? Nos encantaría una respuesta final, sí o no, para poder organizarnos. Por favor actualiza tu confirmación cuando puedas.",
        creditsChargedNote: "Los créditos se cobran cuando se envía cada recordatorio. Asegúrate de tener suficientes créditos en tu saldo en ese momento.",
        skipFollowUpNote: "Puedes omitir este paso y enviar seguimientos más tarde creando un nuevo mensaje desde tu panel.",
        remindersConfigured: "recordatorio(s) programado(s)",

        // Toast messages - Payment
        paymentSuccessClickMessage: "¡Pago exitoso! Haz clic en 'Enviar a los invitados' para continuar.",
        paymentSuccessSendReady: "¡Pago exitoso! Ya puedes enviar tu mensaje.",
        paymentSuccessClickContinue: "¡Pago exitoso! Haz clic en 'Enviar a los invitados' para continuar.",
        paymentSuccessGeneric: "¡Pago exitoso!",
        paymentProcessingWait: "Por favor espera mientras se procesa tu solicitud...",
        paymentSystemUnavailable: "Sistema de pago no disponible. Actualiza e intenta de nuevo.",
        paymentCompletedReady: "¡Pago completado! Tu mensaje está listo para enviar.",
        paymentSuccessEmoji: "🎉 ¡Pago exitoso! Ya puedes enviar tu mensaje.",
        cannotSaveDraftNoEvent: "No se puede guardar borrador: no se seleccionó evento",
        pleaseLoginToSaveDrafts: "Inicia sesión para guardar borradores",
        failedToSaveDraft: "Error al guardar borrador. Intenta de nuevo.",
        campaignSentSuccess: "🎉 ¡Mensaje enviado! {count} créditos utilizados.",
        insufficientCredits: "Créditos insuficientes. Compra más créditos para enviar tu mensaje.",
        errorProcessingCampaign: "Error al procesar el mensaje. Intenta de nuevo.",
        campaignSubmitted: "¡Mensaje enviado! Los mensajes se enviarán automáticamente.",
        campaignScheduledFor: "¡Mensaje programado! Se enviará el {date}.",
        failedToSchedule: "Error al programar el mensaje. Contacta a soporte.",
        verifyEmailBeforeSending: "Confirma tu correo antes de enviar: introduce el código en la pestaña Compartir del editor del formulario y luego envía. Tu enlace ya funciona para tus invitados. No se ha enviado ni cobrado nada.",
        translationComplete: "¡Traducción completada!",
        translationFailed: "La traducción falló. Intenta de nuevo.",
        translationFailedManual: "La traducción falló. Ingresa la traducción manualmente.",
        messageTranslatedTo: "¡Mensaje traducido a {language}!",
        translationFailedRetry: "La traducción falló. Intenta de nuevo o ingresa el mensaje manualmente.",
        pleaseWriteMessageFirst: "Por favor escribe un mensaje primero",
        loadFromContacts: "Mis Contactos",
        noSavedContacts: "Aún no hay contactos guardados. Los contactos a los que envías mensajes en una campaña se guardan automáticamente en tu libreta de direcciones.",
        addressBook: "Libreta de Direcciones",
        addContact: "Agregar Contacto",
        deleteContactConfirm: "¿Eliminar este contacto de tu libreta de direcciones?",
        edit: "Editar",
        delete: "Eliminar",
        save: "Guardar",
        contactNeedsInfo: "Un contacto necesita un nombre y un correo o teléfono.",
        importFromPhone: "Importar del Teléfono",
        importFromPhoneCancelled: "No se seleccionaron contactos.",
        importFromPhoneFailed: "Error al importar contactos: ",
        importFromGoogle: "Importar de Google Contacts",
        noGoogleContactsFound: "No se encontraron contactos en tu cuenta de Google.",
        googleContactsFailed: "Error al cargar Google Contacts: ",
        importFromResponses: "Usar mi lista de invitados",
        importFromResponsesTitle: "Importar desde tu lista de invitados",
        importFromResponsesSubtitle: "Todos los de la lista de invitados de este evento: quienes respondieron y quienes añadiste y aún no han respondido. Solo se puede enviar mensajes a quienes tienen teléfono o correo.",
        noRespondersFound: "Tu lista de invitados está vacía: no hay nadie para importar.",
        noReachableResponders: "Nadie en tu lista de invitados tiene teléfono ni correo, así que no hay a quién enviar mensajes.",
        respondersFailed: "No se pudo cargar tu lista de invitados: ",
        respondersUnreachableNote: "Otras {count} personas de tu lista no tienen teléfono ni correo, así que no se les puede enviar mensajes.",
        respondersAlreadyAdded: "Ya está en tu lista",
        rsvpStatusColumn: "Respuesta",
        rsvpFilterAll: "Todos",
        rsvpFilterYes: "Asisten",
        rsvpFilterMaybe: "Quizás",
        rsvpFilterNo: "No asisten",
        rsvpFilterWaitlisted: "En lista de espera",
        rsvpFilterPending: "Sin responder",
        rsvpStatusYes: "Sí",
        rsvpStatusMaybe: "Quizás",
        rsvpStatusNo: "No",
        rsvpStatusWaitlisted: "Lista de espera",
        rsvpStatusPending: "Sin responder",
        addMoreContacts: "Agregar más contactos",
        exportCsv: "Exportar CSV",
        status: "Estado",
        tags: "Etiquetas",
        allTags: "Todas las etiquetas",
        replaceFile: "Reemplazar archivo",
        maxGuestsCol: "Máx. invitados",
        maxGuestsColHint: "Máximo de invitados que puede traer esta invitación (déjalo en blanco para usar el límite predeterminado del formulario)",
        // The guest-list columns (task #935)
        guestNamesCol: "Nombre(s) de invitados",
        guestNamesColHint: "Cómo añadir nombres de invitados\n• Separa los nombres con punto y coma (;). Las comas también funcionan.\n• Añade (niño) después del nombre de un niño, p. ej. Lucas López (niño).\n• Ejemplo: Sara López; Miguel López; Lucas López (niño)\n• El teléfono y el correo de la fila son de la primera persona de la lista.",
        guestNamesPh: "Sara López; Miguel López",
        groupNameCol: "Nombre del grupo",
        groupNameColHint: "A quién va dirigida la invitación, p. ej. Familia López. Aparece en el sobre y en la bienvenida del formulario; los mensajes saludan a los nombres de los invitados («Hola Sara & Miguel»).\nDéjalo en blanco para un invitado que viene solo. Si solo pones el nombre del grupo, los invitados encuentran su invitación con él y escriben sus nombres; con nombres de invitados, cada uno la encuentra por su propio nombre.",
        groupNamePh: "Familia López",
        contactPreviewTitle: "Así se verá esta invitación",
        contactPreviewEnvelope: "Dirigida a",
        contactPreviewGreetingLine: "Hola, {name}",
        contactPreviewLookup: "Escribiendo cualquiera de estos se encuentra la invitación:",
        contactPreviewNoLookup: "Añade un apellido o un nombre de grupo para que este invitado pueda encontrar la invitación por su nombre.",
        contactPreviewAsksNames: "Aún sin nombres: a quien la encuentre se le pedirán los nombres de su grupo.",
        diffSurnamesTip: "Consejo: añade teléfonos, correos o nombres completos para cada miembro del grupo, así cualquiera de ellos podrá encontrar fácilmente su RSVP.",
        sameNameWarning: "Atención: tienes varios invitados o grupos con el mismo nombre. Añade un correo electrónico o un teléfono a cada uno para que puedan confirmar su identidad al buscar su invitación.",
        lastFirstFlag: "¿Una persona con el apellido primero? Separa a personas distintas con «;».",
        prefillNameLabel: "Completar el nombre de cada invitado en el formulario",
        prefillNameDesc: "Cada enlace personal se abre con el nombre del contacto ya escrito en la casilla del nombre (y en el sobre, si ese interruptor está activado). Desactivalo si tu lista tiene apodos o números compartidos: los invitados escriben su propio nombre; los límites de invitados se mantienen.",
        contactsSelected: "contactos seleccionados",
        addSelected: "Añadir seleccionados",
        selectAll: "Seleccionar Todos",
        importedContactsSummary: "Se importaron {added} contacto(s). {skipped} omitido(s) como duplicado(s).",
        noOrgFound: "No se encontró organización. Configura tu organización primero.",
        noOrgContacts: "No se encontraron contactos en tu organización. Agrega contactos primero.",
        failedToLoadContacts: "Error al cargar contactos: ",
        selectAtLeastOneContact: "Selecciona al menos un contacto.",
        contactsClearedMessage: "Contactos eliminados. Ya puedes subir una nueva lista.",
        unsavedContactsWarning: "Tienes contactos sin guardar. Presiona Cancelar para volver y guardar, o Aceptar para descartar.",
        unsupportedFileType: "Tipo de archivo no compatible. Sube un archivo CSV (.csv) o vCard (.vcf).",
        fileAlreadyUploaded: "El archivo \"{filename}\" ya fue subido.",
        fileReplaced: "Reemplazamos los {replaced} contacto(s) de \"{filename}\" por los {count} del archivo que acabas de subir.",
        fileMergedSummary: "{added} contacto(s) agregado(s) desde \"{filename}\"; {updated} que ya estaban en tu lista se actualizaron con los datos del archivo.",
        failedToProcessFile: "Error al procesar archivo. Verifica el formato e intenta de nuevo.",
        noContactsInFile: "Leímos \"{filename}\" pero no encontramos ningún contacto en él.\n\nColumnas encontradas: {headers}\n\nCada contacto necesita un correo electrónico o un teléfono, bajo un encabezado que reconozcamos — por ejemplo \"name\", \"email\", \"phone\". Cambia los encabezados en tu hoja de cálculo y vuelve a subirla.",
        encodingDamageWarning: "Parece que \"{filename}\" perdió sus caracteres no ingleses: los nombres aparecen como \"???\" o con texto ilegible.\n\nEsto suele ocurrir cuando Excel en un Mac guarda un archivo .csv normal. El texto original ya no está en el archivo, así que importarlo crearía contactos con nombres ilegibles.\n\nPara solucionarlo: en Excel elige Archivo → Guardar como → \"CSV UTF-8 (delimitado por comas)\" y vuelve a subirlo. Google Sheets y Numbers exportan archivos correctos automáticamente.\n\n¿Importar de todos modos?",
        processingFile: "Procesando {filename}...",
        missingNamesWarning: "{count} contacto(s) no tienen nombre — aparecerán como \"Desconocido\". Añádelos en la lista de abajo.",
        // Household invitations (task #908)
        householdCouplesSuggest: "{count} invitación(es) nombran a más de una persona, p. ej. “{example}”. ¿Contar a todos los que nombran, con sus nombres ya completados en el formulario?",
        householdCouplesYes: "Sí, contarlos",
        householdNoThanks: "No, gracias",
        householdFamiliesNote: "{count} invitación(es) son para una familia, p. ej. “{example}”. Añade quién viene en {members} (o fija {maxGuests}) para que el formulario complete sus nombres y los cuente bien.",
        loadingText: "Cargando...",
        verifyingPayment: "Verificando estado del pago...",
        pleaseWaitVerify: "Espera mientras confirmamos tu actualización",
        paymentVerified: "¡Pago verificado!",
        paymentProcessing: "Procesando pago",
        errorVerifyingPayment: "Error al verificar pago",
        validLabel: "Válido",
        checkLabel: "Revisar",
        toCheck: "por revisar",
        phoneCheckChargedNote: "se envía y se cobra tal cual si no lo corriges",
        phoneWarnDoubledCc: "el código de país aparece dos veces",
        phoneWarnCc927: "927 no es un código de país — ¿quisiste decir +972?",
        phoneWarnNanpArea: "en un número +1 el código de área no puede empezar por 0 ni por 1",
        phoneWarnNanpNoCc: "si es un número de EE. UU. o Canadá, necesita +1: {suggest}",
        phoneWarnLength: "un móvil +{cc} tiene {want} dígitos después del código de país; este tiene {got}",
        phoneWarnUkPrefix: "un móvil +44 empieza por 7",
        phoneWarnIlPrefix: "un móvil +972 empieza por 5",
        phoneWarnAssumed: "sin prefijo de país — se leyó como {country} ({number}); cámbialo si no es correcto",
        phoneWarnNeedsCountry: "sin prefijo de país — añádelo al principio, por ejemplo +34",
        phoneWarnInvalid: "no es un número válido ({country}) — revisa los dígitos",
        phoneWarnInvalidAny: "no es un número de teléfono válido — revisa los dígitos",
        phoneWarnLandline: "es un teléfono fijo ({country}) — no puede recibir WhatsApp ni SMS",
        phoneCountryLabel: "Los números sin prefijo de país se leen como",
        phoneCountryHint: "La mayoría de los números de tu lista son de {country}.",
        phoneCountryUse: "Usar {country}",
        contactsLoaded: "Contactos cargados",
        countryUnknown: "Desconocido",
        rowLabel: "Fila",
        deliveryDisclaimer: "La entrega nunca es del 100 %. Una pequeña parte de los mensajes puede quedar retenida por los límites de marketing de Meta, filtros de los operadores, carpetas de spam o datos de contacto incorrectos; es normal en cualquier plataforma de mensajería.",
        tagsCol: "Etiquetas",
        tagsColHint: "En qué grupo está este invitado, p. ej. familia, solo recepción. Separa las etiquetas con comas.\nSi una parte del evento está limitada a ciertas etiquetas (se configura en el editor, en Partes del evento), el enlace personal de este invitado muestra solo las partes que coinciden con sus etiquetas.",
        campaignNameDupAddInstead: "Haz clic aquí para añadir los contactos directamente a tu mensaje existente",
        campaignNameDupAddInsteadSuffix: "en su lugar",
        progressChecklistTitle: "Tu progreso",
        checkCampaignName: "Nombre del mensaje",
        checkAddContacts: "Añadir contactos",
        checkCustomizeMessage: "Personalizar mensaje",
        checkConfigureFollowUp: "Configurar seguimiento",
        checkSendInvitations: "Enviar invitaciones",
        contactsSummaryTitle: "Resumen de contactos",
        totalGuestsAdded: "Total de invitados añadidos",
        contactsImported: "Contactos importados",
        needsAttention: "Requiere atención",
        supportedImportMethods: "Formas de importar",
        manualEntry: "Entrada manual",
        headerOptional: "(Opcional)",
        renameTooltip: "Cambiar nombre",
        gateNoRecipients: "Añade al menos un destinatario antes de pasar al envío.",
        gateNoMessage: "Escribe tu mensaje antes de pasar al envío.",
        gateGoToStep: "Ir al paso {n}",
        sendStalled: "La conexión con nuestros servidores se interrumpió antes de guardar tu mensaje: no se envió nada y no se usaron créditos. Recarga esta página, vuelve a abrir el mensaje y pulsa Enviar de nuevo.",
        loadingSites: "Cargando tus sitios de boda…",
        noWeddingSites: "No se encontró ningún sitio de boda.",
        createWeddingSite: "Crear uno",
        usingSite: "Usando",
        chooseSite: "Elige un sitio de boda…",
        siteNotPublished: "publícalo para usarlo",
        noPublishedSite: "Ninguno de tus sitios de boda está publicado todavía; publica uno para que los invitados puedan confirmar asistencia.",
        rsvpEnabledHint: "Asegúrate de que la página de confirmación de tu sitio esté activada para que los invitados puedan responder.",
        loadingFollowUp: "Cargando mensaje de seguimiento...",
        loadingDraft: "Cargando borrador...",
        creditsAlreadyEnough: "Ya tienes créditos suficientes para este mensaje: revísalo y pulsa Enviar.",
        remindersSkippedBeforeSend: "{count} recordatorio(s) sin programar: su hora es anterior al envío de este mensaje.",
        invalidLabel: "Inválido",
        verifyCountryCode: "⚠ Verifica código de país",
        enterGuestName: "Ingresa nombre del invitado",
        emailPlaceholder: "nombre@ejemplo.com",
        phonePlaceholder: "+12125551234",
        validContacts: "Contactos válidos",
        scheduledTimePast: "La hora programada no puede ser en el pasado",
        recipientsLabel: "Destinatarios",
        noNameLabel: "(sin nombre)",
        removeRecipient: "Quitar",
        removeThisContact: "Quitar este contacto",
        allRecipientsRemoved: "Has quitado a todos los destinatarios. Añade alguno para poder enviar.",
        sendNoFormSelected: "No hay ningún formulario seleccionado para este mensaje. Abre primero un formulario guardado y vuelve a intentar el envío.",
        sendFormNotSaved: "Tu formulario aún no ha terminado de guardarse. Vuelve a abrirlo en el editor, guárdalo e intenta enviar de nuevo.",
        draftSavedFindOnDashboard: "Borrador guardado. Lo encontrarás en Mensajes, en tu panel.",
        processingButton: "Procesando...",
        personalize: "Personalizar:",
        demoLabel: "demo",
        searchContactsPlaceholder: "Buscar por nombre, email o teléfono...",
        loading: "Cargando...",

        // New wizard keys
        fullNamePlus: "+ Nombre Completo",
        firstNamePlus: "+ Nombre",
        emailPlus: "+ Email",
        tableNumberPlus: "+ Número de Mesa",
        tableTagDisabledHint: "Configura el plano de mesas integrado para personalizar con el número de mesa de cada invitado.",
        tableExampleInput: "Tu mesa es la {{table_number}}",
        tableSplitNoticeOne: "1 grupo está sentado en más de una mesa sin el nombre de cada invitado, así que su línea de mesa se verá como \"Dana 2, Dana 3\". Añade el nombre de cada invitado en la lista de invitados para que quede claro.",
        tableSplitNoticeMany: "{count} grupos están sentados en más de una mesa sin el nombre de cada invitado, así que su línea de mesa se verá como \"Dana 2, Dana 3\". Añade el nombre de cada invitado en la lista de invitados para que quede claro.",
        clickToInsert: "Haz clic para insertar — cada invitado recibe su versión personalizada.",
        seeExample: "Ver ejemplo",
        hideExample: "Ocultar ejemplo",
        youWrite: "Escribes:",
        exampleInput: "Hola {{first_name}}, ¡estás invitado a nuestro evento!",
        eachGuestGets: "Cada invitado recibe:",
        sendTestEmailToMe: "Enviarme primero un correo de prueba",
        testEmailSending: "Enviando correo de prueba…",
        testEmailSent: "Correo de prueba enviado a {email}",
        testEmailFailed: "No se pudo enviar el correo de prueba",
        sendTestTitle: "Envíate una prueba",
        sendTestSubtitle: "Recibe una copia real en tu propio móvil y correo, tal como la verán tus invitados.",
        sendTestBtn: "Enviar prueba",
        sendTestCostNote: "La primera prueba de este mensaje es gratis. Después, cada prueba por SMS o WhatsApp usa 1 crédito; las pruebas por correo siempre son gratis.",
        sendTestCostAfterFree: "Ya has usado la prueba gratis de este mensaje. Cada prueba adicional por SMS o WhatsApp usa 1 crédito; las de correo siguen siendo gratis.",
        sendTestPhoneLabel: "Número de móvil para la prueba",
        sendTestPhoneHint: "Tu cuenta no tiene número de móvil, así que escribe uno para enviar la prueba. Lo recordaremos.",
        sendTestPhoneInvalid: "Eso no parece un número de móvil. Usa el formato internacional, por ejemplo +14155550123.",
        sendTestSending: "Enviando tu prueba…",
        sendTestDone: "Prueba enviada",
        sendTestEmailCopyOnly: "El correo es una copia solo para ti — tus invitados no recibirán correo.",
        sendTestFailed: "No se pudo enviar la prueba",
        sendTestCreditReturned: "Te hemos devuelto a tu saldo el crédito de esta prueba.",
        sendTestEmptyMessage: "Escribe primero tu mensaje: todavía no hay nada que probar.",
        sendTestRoutedToWhatsApp: "Número fuera de EE. UU., así que esta prueba usa WhatsApp.",
        // A test parked waiting for Meta, and every way that wait can end (task #604).
        sendTestQueued: "Tu prueba está en cola. WhatsApp todavía está aprobando tu mensaje: la prueba se envía sola en cuanto lo aprueben, así que no tienes que hacer nada más aquí.",
        sendTestQueuedSent: "Aprobado: tu prueba acaba de enviarse a tu WhatsApp.",
        sendTestQueuedFailed: "WhatsApp aprobó tu mensaje, pero no se pudo enviar la prueba. Pulsa Enviar prueba para intentarlo de nuevo.",
        sendTestQueuedNoCredits: "WhatsApp aprobó tu mensaje, pero la prueba en cola necesitaba un crédito y no había ninguno disponible. Recarga y pulsa Enviar prueba otra vez.",
        sendTestQueuedExpired: "Tu prueba en cola caducó antes de que WhatsApp aprobara el mensaje. Pulsa Enviar prueba de nuevo para enviar una ahora.",
        // What the status webhook later says about an accepted WhatsApp test.
        sendTestDelivered: "Entregada en tu WhatsApp ✓",
        sendTestNotDelivered: "La prueba de WhatsApp no se entregó",
        sendTestMetaLimit: "WhatsApp no entregó esta prueba: Meta limita cuántos mensajes de marketing puede recibir un mismo número, y las pruebas repetidas pueden alcanzar ese límite en tu propio número. Tu campaña y tus invitados NO se ven afectados: puedes enviarla con total tranquilidad. Para volver a probar ahora, envía cualquier mensaje (aunque sea «hola») al número de WhatsApp desde el que te llegó la prueba anterior y vuelve a intentarlo: el límite no se aplica dentro de una conversación abierta. Si no, espera unas horas.",
        includeRsvpLink: "Incluir enlace de confirmación en el mensaje",
        rsvpLinkDisabledDesc: "Si se desactiva, el mensaje se envía sin enlace al formulario de confirmación.",
        includeQrCode: "Incluir código QR de registro",
        qrCodeDesc: "Los invitados que confirmaron recibirán su código QR personal.",
        qrCodeWhatsappNote: "En WhatsApp, el código QR reemplazará la imagen del mensaje.",
        finalCampaignSummary: "Resumen Final del Mensaje",
        messagesToSend: "Mensajes a Enviar",
        creditsUsed: "Créditos Usados",
        clickingScheduleNote: "Al hacer clic en \"Programar y Enviar\" se pondrán en cola tus mensajes.",
        scheduleAndSend: "Programar y Enviar",
        canStillGoBack: "Aún puedes volver y hacer cambios antes de enviar.",
        campaignSentSuccessfully: "¡Mensaje enviado exitosamente!",
        messagesBeingDelivered: "Tus {count} mensajes se están entregando ahora.",
        windowWillClose: "Esta ventana se cerrará automáticamente...",
        closeButton: "Cerrar",
        smsConsentAgree: "Acepto los",
        andText: "y",
        buyMessageCredits: "Comprar Créditos",
        campaignRequires: "El mensaje requiere:",
        yourBalanceLabel: "Tu saldo:",
        needLabel: "Necesitas:",
        selectPackage: "Selecciona un paquete:",
        bestValue: "Mejor Valor",
        calcHelper: "¿Cuántos créditos necesito?",
        freeShareBalance: "Tienes {n} créditos de mensajes (cada cuenta empieza con 25 gratis), y tu primer mensaje de prueba también es gratis.",
        freeShareLead: "¿Prefieres enviarlo desde tu teléfono o correo? Sin usar créditos:",
        freeShareCopy: "Copiar enlace",
        freeSharePersonal: "Enlaces personales",
        freeShareCopied: "Enlace copiado",
        calcGuests: "invitados",
        calcMsgs: "mensajes cada uno",
        calcCadence: "La mayoría envía 3 mensajes por invitado: invitación, recordatorio y aviso del día. Los recordatorios suelen ir solo a quienes no respondieron, así que el uso real suele ser menor.",
        creditsAmount: "{count} créditos",
        creditsMoreAmount: "{count} créditos más",
        creditsUnit: "créditos",
        packEnoughForSend: "Suficiente para este mensaje",
        packNeedMore: "Faltan {count}",
        creditsNeverExpireNote: "Los créditos nunca expiran • Úsalos en todos tus formularios",
        haveEnoughCredits: "¡Tienes créditos suficientes!",
        creditsAvailableNeeded: "{balance} créditos disponibles (se necesitan {needed})",
        selectCreditPackage: "Selecciona un paquete de créditos",
        purchaseStartFailed: "No se pudo iniciar la compra. Inténtalo de nuevo.",
        previewNotInteractive: "Vista previa — no interactiva",
        emailTab: "Email",
        whatsappTab: "WhatsApp",
        smsTab: "SMS",
        translating: "Traduciendo...",
        otherLanguage: "Otro Idioma",
        campaignSubmittedSuccessfully: "¡Mensaje enviado exitosamente!",
        submittingCampaign: "Enviando mensaje...",
        submissionFailed: "Envío fallido",
        submitting: "Enviando...",
        errorDetails: "Detalles del error:",
        missingEmailAndPhone: "Faltan email y teléfono",
        invalidEmailFormat: "Formato de email inválido",
        invalidPhoneFormat: "Formato de teléfono inválido",
        paymentSuccessful: "¡Pago exitoso!",
        unknownError: "Error desconocido",
        removeImage: "Eliminar imagen",
        pendingTranslation: "Traducción pendiente",
        removeLanguage: "Eliminar idioma",
        notSpecified: "No especificado",
    }
};

// Register with dashboard language system if available
if (window.DashboardLanguageSystem) {
    window.DashboardLanguageSystem.registerLanguageContent('es', window.SpanishDashboardContent);
}
